import { render, staticRenderFns } from "./BatchModifyAttribute.vue?vue&type=template&id=c35819e6&scoped=true"
import script from "./BatchModifyAttribute.vue?vue&type=script&lang=js"
export * from "./BatchModifyAttribute.vue?vue&type=script&lang=js"
import style0 from "./batch-modify.css?vue&type=style&index=0&id=c35819e6&prod&scoped=true&lang=css&external"
import style1 from "./BatchModifyAttribute.vue?vue&type=style&index=1&id=c35819e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.43_cache-loader@4.1.0_webpack@4.47.0_supports-_28b733ef3ef89602fda58894ac543489/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35819e6",
  null
  
)

export default component.exports